export default __webpack_public_path__ + "static/media/robotics_logo.714ccf27.svg";